export type ApiProgressStatus = "REAL" | "MOCK" | "PARTIAL" | "NONE";
export type UiProgressStatus = "DONE" | "PLACEHOLDER" | "LEGACY";

export type PageApiProgress = {
  module: string;
  page: string;
  route: string;
  uiStatus: UiProgressStatus;
  apiStatus: ApiProgressStatus;
  endpoints: string[];
  note?: string;
};

export const pageApiProgressList: PageApiProgress[] = [
  {
    module: "运营中心",
    page: "项目管理",
    route: "/operation/project-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/saas/project/*", "/user/auth/tenant-context"],
    note: "包含管理端进入租户逻辑",
  },
  {
    module: "运营中心",
    page: "通讯录",
    route: "/operation/address-book",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/saas/contact/*"],
  },
  {
    module: "运营中心",
    page: "终端管理",
    route: "/operation/terminal-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/saas/device-manage/*"],
  },
  {
    module: "系统管理",
    page: "系统用户",
    route: "/system/user-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/user/manage/list", "/user/manage", "/user/manage/{userId}/status"],
  },
  {
    module: "系统管理",
    page: "角色管理",
    route: "/system/roles-manage",
    uiStatus: "LEGACY",
    apiStatus: "REAL",
    endpoints: ["/user/role/list", "/user/permission/tree", "/user/role/{roleId}/permissions"],
  },
  {
    module: "系统管理",
    page: "菜单管理",
    route: "/system/menu-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/common/dev/menus*"],
  },
  {
    module: "系统管理",
    page: "系统参数",
    route: "/system/params",
    uiStatus: "PLACEHOLDER",
    apiStatus: "NONE",
    endpoints: [],
  },
  {
    module: "首页",
    page: "租户首页",
    route: "/tenant/home",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/energy/home/kpi",
      "/energy/home/pareto",
      "/energy/home/terminals/pareto",
      "/energy/risk-diagnosis/risk-index/today-hourly",
      "/energy/risk-diagnosis/hazards",
      "/energy/risk-diagnosis/alarms",
    ],
    note: "已对接能耗概览、区域/终端帕累托、风险指数、隐患列表、告警列表",
  },
  {
    module: "监测中心",
    page: "终端监控",
    route: "/tenant/device-monitor/terminal-monitor",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/mobile/monitor/*"],
  },
  {
    module: "监测中心",
    page: "风险监控",
    route: "/tenant/device-monitor/risk-monitor",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/risk-diagnosis/*"],
  },
  {
    module: "监测中心",
    page: "抄表清单",
    route: "/tenant/device-monitor/meter-reading-list",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/read/list", "/energy/read/export", "/oam/area/tree"],
    note: "测试版本-完成",
  },
  {
    module: "监测中心",
    page: "电能质量",
    route: "/tenant/device-monitor/power-quality",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/power-quality/*"],
    note: "测试版本-完成",
  },
  {
    module: "监测中心",
    page: "历史数据",
    route: "/tenant/device-monitor/history-data",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/energy/history/list",
      "/energy/history/export",
      "/energy/history/terminals/{serialNum}/chart-properties",
      "/energy/history/terminals/{serialNum}/properties/{propertyId}/trend",
      "/oam/area/tree",
      "/oam/device/listNoPage",
      "/oam/item/internal/meta/tree",
    ],
    note: "测试版本-完成",
  },
  {
    module: "AI智能化",
    page: "资产健康",
    route: "/tenant/ai/asset-health",
    uiStatus: "PLACEHOLDER",
    apiStatus: "NONE",
    endpoints: [],
  },
  {
    module: "AI智能化",
    page: "智能诊断",
    route: "/tenant/ai/smart-diagnosis",
    uiStatus: "PLACEHOLDER",
    apiStatus: "NONE",
    endpoints: [],
  },
  {
    module: "能耗统计",
    page: "能耗概览",
    route: "/tenant/energy-stat/energy-overview",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/oam/area/tree",
      "/energy/overview/kpi",
      "/energy/overview/pareto",
      "/energy/overview/terminals/pareto",
      "/energy/overview/trend",
    ],
    note: "测试版本-完成",
  },
  {
    module: "能耗统计",
    page: "历史能耗",
    route: "/tenant/energy-stat/history-energy",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/history-consume/*"],
    note: "测试版本-完成",
  },
  {
    module: "能耗统计",
    page: "区域能耗",
    route: "/tenant/energy-stat/area-energy",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/area/*", "/area/trend/export"],
  },
  {
    module: "能耗统计",
    page: "分项能耗",
    route: "/tenant/energy-stat/item-energy",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/energy/itemized-energy/*"],
  },
  {
    module: "运维中心",
    page: "终端管理",
    route: "/tenant/ops/terminal-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/oam/device/list",
      "/oam/device/listNoPage",
      "/oam/device/unbound",
      "/oam/device",
      "/oam/device/{deviceId}",
      "/oam/device/{deviceId}/status",
      "/oam/area/tree",
      "/oam/item/internal/meta/tree",
      "/user/fixed",
      "/common/common/meta/device-types",
    ],
    note: "测试版本-完成",
  },
  {
    module: "运维中心",
    page: "区域管理",
    route: "/tenant/ops/area-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/oam/area/list",
      "/oam/area/tree",
      "/oam/area",
      "/oam/area/{areaId}",
      "/oam/area/{areaId}/status",
    ],
    note: "测试版本-完成",
  },
  {
    module: "运维中心",
    page: "分项管理",
    route: "/tenant/ops/item-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: [
      "/oam/item/internal/meta/tree",
      "/oam/item",
      "/oam/item/{itemType}/basic",
      "/oam/item/{itemType}/status",
      "/oam/item/{itemType}",
    ],
    note: "测试版本-完成",
  },
  {
    module: "运维中心",
    page: "配额阈值设置",
    route: "/tenant/ops/quota-threshold",
    uiStatus: "DONE",
    apiStatus: "MOCK",
    endpoints: [],
  },
  {
    module: "运维中心",
    page: "告警中心",
    route: "/tenant/ops/alarm-center",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/oam/alarm/web/*", "/oam/work-order/web", "/user/fixed"],
  },
  {
    module: "运维中心",
    page: "工单管理",
    route: "/tenant/ops/work-order",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/oam/work-order/web/*", "/user/fixed"],
  },
  {
    module: "系统管理",
    page: "用户管理",
    route: "/tenant/system/user-manage",
    uiStatus: "DONE",
    apiStatus: "REAL",
    endpoints: ["/user/manage/list", "/user/manage", "/oam/area/tree"],
  },
  {
    module: "系统管理",
    page: "角色权限",
    route: "/tenant/system/role-permission",
    uiStatus: "LEGACY",
    apiStatus: "REAL",
    endpoints: ["/user/role/list", "/user/permission/tree", "/user/role/{roleId}/permissions"],
  },
  {
    module: "系统管理",
    page: "操作日志",
    route: "/tenant/system/operation-log",
    uiStatus: "DONE",
    apiStatus: "MOCK",
    endpoints: [],
  },
];
